<div class="rt-split">
  <app-auth-brand-panel></app-auth-brand-panel>
  <div class="rt-login-col">
    <div class="rt-login-form" *ngIf="!resetPassword">
      <h2 class="rt-title">{{ 'app.email_verification.sign_in' | translate }}</h2>
      <app-migration-notice></app-migration-notice>
      <form #loginForm="ngForm" (ngSubmit)="verifyEmail()">
        <div class="rt-field">
          <ejs-textbox class="rt-input" [(ngModel)]="email" name="email" [placeholder]="'app.email_verification.enter_email' | translate"
            required #emailRef="ngModel"></ejs-textbox>
          <div *ngIf="errorMessage" class="rt-validation">{{ errorMessage }}</div>
        </div>

        <button ejs-button type="submit" class="rt-btn-primary">{{ 'app.email_verification.next' | translate }}</button>

        <div class="rt-or-divider">{{ 'app.email_verification.or' | translate }}</div>

        <div class="rt-alt">
          <!-- No backend Google OAuth integration exists yet (no client id, no
               Identity Services script, no token-exchange endpoint) -- disabled
               with a "coming soon" title rather than wired to a fabricated call,
               so the control is honest about being unavailable instead of a
               silent dead end. -->
          <button type="button" class="rt-btn-secondary rt-btn-google" disabled [title]="'app.email_verification.google_coming_soon' | translate">
            <img src="assets/vectors/google-icon.svg" [alt]="'app.email_verification.google_icon' | translate" />
            <span>{{ 'app.email_verification.sign_in_with_google' | translate }}</span>
          </button>
        </div>

        <div class="rt-links">
          <a class="rt-link" [title]="'app.email_verification.account_locked' | translate" (click)="unlockAccount()">{{ 'app.email_verification.account_locked' | translate }}</a>
          <span class="rt-link rt-link-static">{{ 'app.email_verification.login_help' | translate }}</span>
        </div>
      </form>
    </div>
  </div>
</div>
